module.exports = __webpack_public_path__ + "static/img/pmglab_logo_rev.4c4f26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pmglab_logo_rev.png
// module id = qEx1
// module chunks = 1